import CityPageTemplate from "../city-template/CityPageTemplate";
import { collegeStationConfig } from "./data";

export default function CollegeStationPage() {
  return <CityPageTemplate config={collegeStationConfig} />;
}